/**
 * Given a list of sorted `points` and a `point`, this will give the index
 * inside `points` of the closest point.
 * @param {Array.<number>} points
 * @param {number} point
 * @returns {number}
 */
export default function nearestIndex(points, point) {
	for (var i = 0; i < points.length - 1; i++) {
		if (point > (points[i] + points[i + 1]) / 2) {
			continue;
		}
		return i;
	}
	return points.length - 1;
}



// WEBPACK FOOTER //
// ./lib/pagehandler/utils/nearestIndex.js